<template>
  <section class="see-in-action">
    <figure>
      <img :src="require('@/assets/home/cta.jpg')" alt="" />
    </figure>
    <div class="container">
      <h6 class="t-md">Request a free demo</h6>
      <h5 class="t-lg">See it in action</h5>
      <p class="t-r">Ready to transform your design process?</p>
      <ButtonSecondary @click.native="$router.push({ name: 'demo' })">Request a Demo</ButtonSecondary>
    </div>
  </section>
</template>

<script>
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'

export default {
  name: 'SeeInAction',
  components: {
    ButtonSecondary,
  },
}
</script>

<style lang="scss">
.see-in-action {
  position: relative;
  background-color: rgba(0, 0, 0, 0.5);

  figure {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin: 0;
    z-index: -1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 756px;
  }

  .t-md {
    color: var(--Text-Text_White) !important;
    text-align: center;
    font-family: Unbounded;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.18px;
    margin-bottom: 10px;
  }
  .t-lg {
    color: var(--Text-Text_White) !important;
    text-align: center;
    font-family: Unbounded;
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -1.56px;
    margin-bottom: 15px;
  }
  .t-r {
    color: var(--Text-Text_White) !important;
    text-align: center;
    font-family: Unbounded;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.18px;
    margin-bottom: 25px;
  }
}

@media (max-width: 480px) {
  .see-in-action {
    .container {
      display: flex !important;
      padding: 20px;
    }
    .t-lg {
      font-size: 30px;
    }
  }
}
</style>
